import * as React from "react";
import {useEffect, useState} from "react";
import {Button, Card, Form, Input, Label} from "reactstrap";
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import {AccountCircle} from "@mui/icons-material";

const LoginCard= (props)=>{

  const { onClose, selectedValue, open, upd, loginF, regNew } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };

  return (
    <Dialog  className="p-4" onClose={handleClose} open={open}>
      <DialogTitle>Login</DialogTitle>
      <Card className="p-2">
        <Form>

            <div className="p-2">
              <Label
                className="visually-hidden"
                for="exampleEmail"
              >
                Email
              </Label>
              <Input
                id="login"
                name="login"
                placeholder="login"
                type="email"
              />
            </div>
            <div className="p-2">
              <Label
                className="visually-hidden"
                for="examplePassword"
              >
                Password
              </Label>
              <Input onChange={(e)=>upd(e)}
                     id="password"
                     name="password"
                     placeholder="password"
                     type="password"
              />
            </div>

            <div className="p-2">
              <Button onClick={()=>loginF()} >
                Submit
              </Button>
            </div>

        </Form>
        <Form>

          <div className="p-2">
            <Label
                className="visually-hidden"
                for="exampleEmail"
            >
              Email
            </Label>
            <Input
                id="login1"
                name="login"
                placeholder="login"
                type="email"
            />
          </div>
          <div className="p-2">
            <Label
                className="visually-hidden"
                for="examplePassword"
            >
              Password
            </Label>
            <Input
                   id="password1"
                   name="password"
                   placeholder="password"
                   type="password"
            />
          </div>

          <div className="p-2">
            <Button onClick={()=>regNew()} >
              Submit
            </Button>
          </div>

        </Form>
      </Card>
    </Dialog>
  )
}
const User= async ()=>{
  const headers ={
  Accept: 'application/json',
  'Content-Type': 'application/json',
  Authorization: 'Bearer ' + localStorage.getItem('token')
};
  const url=process.env.REACT_APP_api+"api/users";
 return await fetch(url, {
    headers:headers

  }).then(response=>response.json());

}
const Login = (p) => {
  const token= localStorage.getItem('token');
  const [user, setUser] = useState(null);
  const [open, setOpen] = useState(false);

const update = async ()=>{
  const headers ={
    Accept: 'application/json',
      'Content-Type': 'application/json',
    Authorization: 'Bearer ' + localStorage.getItem('token')
  };

  const url=process.env.REACT_APP_api+"oauth/token";


  await fetch(url, {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    redirect: "follow",
    referrerPolicy: "no-referrer",
    body: JSON.stringify({
      grant_type: 'password',
      client_id: '2',
      client_secret: 'YfIZVVJH5OMQ1R4XDm8eC7BNG49q3L5lWVVlZjTy',
      username: 'ap@facereplays.com23',
      password: 'Pompon_22',
      scope: ''
    }),
  }).then(response=>response.json()).then(
    r=>{

      localStorage.setItem('token',r.access_token);


    }

  );
}



const upd=()=>{




}

  useEffect(() => {


    ( token && !user) && getUser();
  }, []);//

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);

  };

  const getUser =  async ()=>{
const h ={Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
    const url=process.env.REACT_APP_api+"api/users";
try{
    await fetch(url, {
      headers:h


    }).then(response=>response.json()).then(

      r=> {

        if (r.data.user.email) {
        setUser(r.data.user);

        }

      }
    )} catch (e) {
  
}
  }
  //
  const logout =  async ()=>{
    setUser(null);
    localStorage.removeItem('token');
  }
  const regNew =  async ()=>{
    const url=process.env.REACT_APP_api+"api/register";
    await fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: JSON.stringify({
        email: document.getElementById('login1').value,
       first_name: document.getElementById('login1').value,
        password: document.getElementById('password1').value,

      }),
    }).then(response=>response.json()).then(
        r=>{
console.log(r);
          localStorage.setItem('token',r.token);
  // loginF(document.getElementById('login1').value,document.getElementById('password1').value);
        })

  }
  const loginF =  async (l=null,p=null)=>{
    const url= process.env.REACT_APP_api+"oauth/token";
    //console.log( process.env.REACT_APP_Secret1);
      await fetch(url, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
        body: JSON.stringify({

          grant_type: 'password',
    client_id:
    process.env.REACT_APP_Client3,
          client_secret: process.env.REACT_APP_Secret3,
          username: l ? l : document.getElementById('login').value,
          password: p ? p : document.getElementById('password').value,
          scope: ''
        }),
      }).then(response=>response.json()).then(
        r=>{
          if(r.access_token){
          localStorage.setItem('token',r.access_token);
            alert('Successfully logged in.');
            setOpen(false);
         getUser();



        }

        }

      );

    //  return r;




  }
  return (
<div>
  {!user ? (
    <Button  onClick={handleClickOpen}>login</Button>

  ) : (
    <>
    <Button > <AccountCircle/> {user.email}</Button>
      <Button onClick={()=>logout()} > logout</Button>
    </>
  )}
<LoginCard open={open} upd={upd} loginF={loginF}
      regNew={regNew}     onClose={handleClose}/>
</div>
  )
}
export {Login,User};
